import * as React from "react"
import { ModuleNameContext } from "src/frontend/components/Shared/Contexts/ModuleNameContext"

export function useModuleName() {
  return React.useContext(ModuleNameContext)
}
